module.exports = __webpack_public_path__ + "img/corporate.4f27f0e8.svg";